<template>
  <div>
    <app-loading v-bind:loading="loading"></app-loading>
    <div class="journey-nav-container">
      <div class="container">
        <div class="navigation-bar" v-if="selector && selector === 'lot'">
          <div class="nav" :class="{'prev': activeIds.lotid, 'current': currentPage === 'map'}">
            <a  @click="selectLot()">
              <app-selector :name="'lot'" :number="'1'"></app-selector>
            </a>
          </div>
          <div class="nav">
            <img v-if="activeIds.lotid" :src="require('@/assets/icons/check.svg')" alt="">
            <img v-if="!activeIds.lotid" :src="require('@/assets/icons/next.svg')" alt="">
          </div>
          <div class="nav is-disabled"
               :class="{'prev': activeIds.homeid && currentPage !== 'homes', 'current': currentPage === 'homes'}">
            <a v-if="currentPage === 'map'"
               uk-tooltip="title: Select a lot from the map below in order to continue; pos: bottom">
              <app-selector :name="'home'" :number="'2'"></app-selector>
            </a>
            <a v-if="currentPage === 'homes'">
              <app-selector :name="'home'" :number="'2'"></app-selector>
            </a>
            <a @click="selectHome()" v-if="currentPage !== 'homes' && activeIds.homeid">
              <app-selector :name="'home'" :number="'2'"></app-selector>
            </a>
          </div>
          <div class="nav">
            <img v-if="activeIds.homeid && currentPage !== 'homes'" :src="require('@/assets/icons/check.svg')" alt="">
            <img v-if="!activeIds.homeid || currentPage === 'homes'" :src="require('@/assets/icons/next.svg')" alt="">
          </div>
          <div class="nav"
               :class="{'prev': activeIds.facadeid && currentPage !== 'facade', 'current': currentPage === 'facade', 'next': currentPage === 'homes' && activeIds.homeid}">
            <a v-if="currentPage === 'map'"
               uk-tooltip="title: Select a lot from the map below in order to continue; pos: bottom">
              <app-selector :name="'exterior'" :number="'3'"></app-selector>
            </a>
            <a v-if="currentPage === 'homes' && !activeIds.homeid"
               uk-tooltip="title: Select a home and confirm in order to continue; pos: bottom">
              <app-selector :name="'exterior'" :number="'3'"></app-selector>
            </a>
            <a v-if="currentPage === 'facade'">
              <app-selector :name="'exterior'" :number="'3'"></app-selector>
            </a>
            <a @click="selectFacade()" v-if="currentPage === 'homes' && activeIds.homeid">
              <app-selector :name="'exterior'" :number="'3'"></app-selector>
            </a>
          </div>
          <div class="nav">
            <img :src="require('@/assets/icons/next.svg')" alt="">
          </div>
          <div class="nav" :class="{'next': currentPage === 'facade'}">
            <a v-if="!activeIds.lotid"
               uk-tooltip="title: Select a lot from the map below in order to continue; pos: bottom">
              <app-selector :name="'explore'" :number="'4'"></app-selector>
            </a>
            <a v-if="currentPage === 'homes' && activeIds.lotid"
               uk-tooltip="title: Select a home and confirm in order to continue; pos: bottom">
              <app-selector :name="'explore'" :number="'4'"></app-selector>
            </a>
            <a v-if="currentPage === 'facade'" @click="createPackage()">
              <app-selector :name="'explore'" :number="'4'"></app-selector>
            </a>
          </div>
        </div>

        <div class="navigation-bar" v-if="selector && selector === 'home'">
          <div class="nav"
               :class="{'prev': activeIds.homeid && currentPage !== 'homes', 'current': currentPage === 'homes'}"
               @click="selectHome()">
            <a>
              <app-selector :name="'home'" :number="'1'"></app-selector>
            </a>
          </div>

          <div class="nav">
            <img v-if="activeIds.homeid && currentPage !== 'homes'" :src="require('@/assets/icons/check.svg')" alt="">
            <img v-if="!activeIds.homeid || currentPage === 'homes'" :src="require('@/assets/icons/next.svg')" alt="">
          </div>

          <div class="nav"
               :class="{'prev': activeIds.facadeid && currentPage !== 'facade', 'current': currentPage === 'facade', 'next': currentPage === 'homes' && activeIds.homeid}">
            <a v-if="!activeIds.homeid" uk-tooltip="title: Select a home and confirm in order to continue; pos: bottom">
              <app-selector :name="'exterior'" :number="'2'"></app-selector>
            </a>
            <a v-if="activeIds.homeid" @click="selectFacade()">
              <app-selector :name="'exterior'" :number="'2'"></app-selector>
            </a>
          </div>
          <div class="nav">
            <img v-if="activeIds.facadeid && currentPage !== 'facade'" :src="require('@/assets/icons/check.svg')" alt="">
            <img v-if="!activeIds.facadeid || currentPage === 'facade'" :src="require('@/assets/icons/next.svg')" alt="">
          </div>

          <div class="nav" :class="{'prev': activeIds.lotid, 'current': currentPage === 'map'}">
            <a v-if="currentPage === 'homes'"
               uk-tooltip="title: Select home and matching exterior in order to continue; pos: bottom">
              <app-selector :name="'lot'" :number="'3'"></app-selector>
            </a>
            <a v-if="currentPage === 'facade'"
               uk-tooltip="title: Select and confirm exterior in order to continue; pos: bottom">
              <app-selector :name="'lot'" :number="'3'"></app-selector>
            </a>
            <a v-if="currentPage === 'map'">
              <app-selector :name="'lot'" :number="'3'"></app-selector>
            </a>
          </div>
          <div class="nav">
            <img v-if="activeIds.lotid" :src="require('@/assets/icons/check.svg')" alt="">
            <img v-if="!activeIds.lotid" :src="require('@/assets/icons/next.svg')" alt="">
          </div>


          <div class="nav" :class="{'next': currentPage === 'map'}">
            <a v-if="currentPage === 'homes'"
               uk-tooltip="title: Select home and matching exterior in order to continue; pos: bottom">
              <app-selector :name="'explore'" :number="'4'"></app-selector>
            </a>

            <a v-if="currentPage === 'facade'"
               uk-tooltip="title: Select and confirm exterior in order to continue; pos: bottom">
              <app-selector :name="'explore'" :number="'4'"></app-selector>
            </a>

            <a v-if="currentPage === 'map'"
               uk-tooltip="title: Select lot from the map below in order to continue; pos: bottom">
              <app-selector :name="'explore'" :number="'4'"></app-selector>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Journey from "@/mixins/journey/Journey";
import Selector from "@/components/journey/nav/Selector";
import Loading from "@/components/journey/Loading";

export default {
  name: 'community',
  mixins: [Journey],
  data() {
    return {
      currentPage: null,
      listeningToMutation: false,
      loading: false,
      selector: null,
      sub: null,
    }
  },
  components: {
    'app-selector': Selector,
    'app-loading': Loading
  },
  props: {
    activeHome: {
      type: Object
    },
    activeFacade: {
      type: Object
    },
    activeLot: {
      type: Object
    },
    nextTrigger: Boolean
  },
  watch: {
    activeHome: function (val, oldval) {
      if (val) {
        this.activeIds.homeid = val.cpidstring;
      }
    },
    activeFacade: function (val, oldval) {
      if (val) {
        this.activeIds.facadeid = val.cpidstring;
      }
    },
    activeLot: function (val, oldval) {
      if (val) {
        this.activeIds.lotid = val.cpidstring;
        this.activeIds.lotcpid = val.lotcpid;
        return this.checkLotPage();
      }
    },
    nextTrigger: function (val, oldval) {
      if (val) {
        switch (this.currentPage) {
          case 'homes':
            return this.selectFacade();
          case 'facade':
            // this.checkFacadePage();
            return this.checkFacadePage()
          case 'map':
          // return this.checkLotPage();
          default:
            return this.reset();
        }
      }
    }
  },
  created() {
    this.getCurrentPage();
    this.getIds();
  },
  beforeDestroy() {
    if (this.sub) {
      this.sub()
    }
  },
  methods: {
    getCreatedPackage: function () {
      if (!this.listeningToMutation) {
        this.listeningToMutation = true;
        this.sub = this.$store.subscribe((mutation, state) => {
          if (mutation.type === 'setPackageCreation') {
            return this.$router.push({
              path: '/community/package/' + state.communityStore.packageRecordId,
            })
          }
        })
      }
    },

    getCurrentPage: function () {
      this.currentPage = this.$route.name;
      if (this.currentPage === 'homes' || this.currentPage === 'facade') {
        if (this.$route.query.lotid && this.$route.query.lotcpid) {
          this.selector = 'lot'
        } else {
          this.selector = 'home'
        }
      }

      if (this.currentPage === 'map') {
        if (this.$route.query.homeid && this.$route.query.facadeid) {
          this.selector = 'home';
        } else {
          this.selector = 'lot';
        }
      }
    },

    selectHome: function () {
      if (this.activeIds.lotid) {
        return this.$router.push({
          path: '/community/homes',
          query: {
            lotid: this.activeIds.lotid,
            lotcpid: this.activeIds.lotcpid
          }
        })
      } else {
        return this.$router.push({
          path: '/community/homes'
        })
      }
    },

    selectLot: function () {
      return this.$router.push({
        path: '/community/lot',
      })
    },

    selectFacade: function () {
      if (this.activeIds.homeid) {
        const id = [{
          key: 'homeid',
          value: this.activeIds.home
        }];
        this.setIds(id);
        this.goToFacade();
      }
    },

    checkFacadePage: function () {
      if (this.activeIds.lotid && this.activeIds.lotcpid) {
        return this.createPackage();
      }
    },

    checkLotPage: function () {
      if (this.activeIds.lotid && this.activeIds.lotcpid && this.activeIds.facadeid && this.activeIds.homeid) {
        this.createPackage();
      } else {
        return this.$router.push({
          path: '/community/homes',
          query: {lotid: this.activeIds.lotid, lotcpid: this.activeIds.lotcpid}
        });
      }
    },

    createPackage: function () {
      this.loading = true;
      this.goToPackage();
      this.getCreatedPackage();
    },

    reset: function () {
      this.$router.push({
        path: '/community/'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/nav/Navigation.vue